export default __webpack_public_path__ + "static/media/logo.8fad0542.svg";